module.exports = __webpack_public_path__ + "img/drFraude2.e950ead5.png";